import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const CONSENT_KEY = "grandlinecardss-cookie-consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed inset-x-0 bottom-0 z-[80] border-t border-white/10 bg-[#050505]/95 backdrop-blur-xl"
        >
          <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 px-6 py-5 md:flex-row md:items-center md:justify-between md:px-12">
            <div className="flex items-start gap-3">
              <Cookie size={18} className="mt-0.5 shrink-0 text-[#cba153]" />
              <p className="max-w-xl text-sm font-light leading-relaxed text-[#888]">
                Questo sito utilizza solo cookie tecnici necessari al suo
                funzionamento. Proseguendo accetti la nostra{" "}
                <Link
                  to="/privacy-policy"
                  data-testid="cookie-privacy-link"
                  className="text-[#cba153] underline underline-offset-4 transition-colors duration-300 hover:text-[#fafafa]"
                >
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
            <button
              onClick={accept}
              data-testid="cookie-accept-button"
              className="w-full shrink-0 rounded-full bg-[#cba153] px-7 py-3 text-center font-mono text-xs uppercase tracking-[0.2em] text-black transition-transform duration-300 hover:scale-105 md:w-auto"
            >
              Accetta
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
